function sanitizedUrl(url) {
  if (!url) return '';

  let cleanUrl = url;

  // if the last character is a / then trimmit
  if (cleanUrl.charAt(cleanUrl.length - 1) === '/') {
    cleanUrl = cleanUrl.substr(0, cleanUrl.length - 1);
  }

  // If URL already includes a scheme, return as-is
  if (cleanUrl.substring(0, 7) === 'http://' || cleanUrl.substring(0, 8) === 'https://') {
    return cleanUrl;
  }

  if (cleanUrl.substring(0, 4) === 'www.') {
    cleanUrl = `https://${cleanUrl}`;
    return cleanUrl;
  }
  cleanUrl = `https://www.${cleanUrl}`;

  return cleanUrl;
}

export default sanitizedUrl;
